<template>
      <b-modal :active.sync="isSourceMetaModalActive" has-modal-card :onCancel="this.switchIt">
      <form action="">
        <div class="modal-card">
          <header class="modal-card-head">
            <!-- <p class="modal-card-title">DATA SOURCE</p> -->
            <p class="modal-card-title"><b>DATA SOURCE: </b> {{this.sourceInfo.name}}</p>
          </header>
          <section class="modal-card-body">
            <div class="tabs is-boxed is-right">
              <!-- On click change class of li to is-active and populate data. -->
              <!-- <ul>
                        <li v-for="i in dataSource" :key="i" :value="i" :class="{'is-active':i==isActive}" @click="dataSourceClicked(i)">
                          <a>
                            <span>{{i}}</span>
                          </a>
                        </li>
                      </ul> -->
            </div>
            <div class="panel panel-info">
              <div class="panel-heading">FULL NAME</div>
              <div class="panel-body">
                <!-- <span v-html="selectedDescription"></span> -->
                <span>{{this.sourceInfo.fullName}}</span>
              </div>
            </div>
            <div class="panel panel-info">
              <div class="panel-heading">DESCRIPTION</div>
              <div class="panel-body">
                <!-- <span v-html="selectedDescription"></span> -->
                <span>{{this.sourceInfo.description}}</span>
              </div>
            </div>
            <div class="panel panel-info">
              <div class="panel-heading col-xs-6">YEARS WITH AVAILABLE DATA</div>
              <div class="panel-heading col-xs-6">NEXT AVAILABLE DATA</div>
              <div class="panel-body">
                <span class="row">
                          <div class="col-xs-6">{{this.sourceInfo.available}}</div>
                          <div class="col-xs-6">{{this.sourceInfo.nextAvailable}}</div>
                        </span>
              </div>

              

            </div>
          
            <div class="panel panel-info">
              <div class="panel-heading">LINKS</div>
              <div class="panel-body">
                <!-- <span v-if="this.links.length>1"> -->
                <!-- <span v-for="i in this.sourceInfo.links" :key="i">
                    <a :href="i" target='_blank'>{{i}}</a><br>
                </span> -->
                

                <!-- <span><a v-bind:href="linkFirst"> {{ linkFirst }}</a></span> -->
                <!-- <span  v-for="firstLink in firstLink" v-bind:key="firstLink">
                  {{firstLink.trim().split(' ')}}
                  <a v-bind:href="firstLink.split(' ')[1]" target="_blank">{{ firstLink.split(' ')[0] }}<br></a>
                </span> -->
                <span  v-for="firstLink in firstLink" v-bind:key="firstLink">
                  
                  <a v-bind:href="firstLink.trim().split(' ')[1]" target="_blank">{{ firstLink.trim().split(' ')[0] }}<br></a>
                </span>
              </div>
            </div>
            <div class="panel panel-info">
              <div class="panel-heading">METHODOLOGY</div>
              <div class="panel-body">
                <!-- <span v-html="selectedDescription"></span> -->
                <span>{{this.sourceInfo.method}}</span>
              </div>
            </div>
            <div class="panel panel-info">
              <div class="panel-heading">SUB-NATIONAL DATA AVAILABLE</div>
              <div class="panel-body">
                <!-- <span v-html="selectedDescription"></span> -->
                <span> {{this.sourceInfo.subNatVal}}</span>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-danger pull-right" type="button" @click="switchIt">CLOSE</button>
            <!-- <button class="button is-success">Do something</button> -->
          </footer>
        </div>
      </form>
    </b-modal>
</template>

<script>
export default {
  name: "tableModal",
  props: ["src", "sourceMetaData"],

  data () {
    return {
      isSourceMetaModalActive: false,
      sourceInfo: {},
      firstLink:[],
      linkFirst:'',
    }
  },
  methods: {
    switchIt(){
      this.isSourceMetaModalActive = false;
      this.$emit('switchOff');
    },
    viewSourceMetadata(theSource) {

      for (var i = 0; i < this.sourceMetaData.length; i++) {
        if (theSource == this.sourceMetaData[i][0]) {
          this.sourceInfo.name = this.sourceMetaData[i][0];
          this.sourceInfo.fullName = this.sourceMetaData[i][1];
          this.sourceInfo.description = this.sourceMetaData[i][2];
          this.sourceInfo.available = this.sourceMetaData[i][3];
          this.sourceInfo.nextAvailable = this.sourceMetaData[i][4];
          this.sourceInfo.links = this.sourceMetaData[i][5].replace(/\s+/g, '').split(',');
          // this.sourceInfo.links = this.sourceMetaData[i][5];
          this.sourceInfo.method = this.sourceMetaData[i][6];
          this.sourceInfo.subNatVal = this.sourceMetaData[i][7];
          // console.log(this.sourceMetaData[i][5]);

          var check1 = this.sourceMetaData[i][5];
          var check2 = check1.split(', ');

          // console.log(check2);

          // var check3 = check2.split(' ');
          
          this.firstLink = check2;
          this.linkFirst = this.firstLink;
          // console.log(this.firstLink);
          
          
        }
      }

      this.isSourceMetaModalActive = !this.isSourceMetaModalActive;

    }
  },

  mounted() {
    //console.log(this.src);
    this.viewSourceMetadata(this.src);
    //console.log(this.src);
  }
}
</script>


// WEBPACK FOOTER //
// mt.vue?40866a44